import { FormControl, InputLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux"
import { BlueHoverButton } from "../../../../components/Inputs/BlueHoverButton";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import Lista from "../../../../components/Lista";
import Popup from "../../../../components/Popup";
import servAnalises from "../../../../services/login/servAnalises";
import { columnsAnaliseSolicitacaoCompartilhamentoAnalise } from "./Lista";
import styles from "./SolicitacaoSolCompartilhamentoAnalise.module.css";
import Cadastro from "../Cadastro";
import { style as modalstyle } from "../../../../components/Loading/Loading";
import { Modal, Box, CircularProgress } from "@mui/material";
import { ResultadoAnalise } from "./ResultadoAnalise/ResultadoAnalise";
import servSolicitacaoCompartilhamento from "../../../../services/login/servSolicitacaoCompartilhamento";
import servConsultaDisponibilidade from "../../../../services/login/servConsultaDisponibilidade";

function Analises() {
    const user = useSelector(state => state.user);
    const [isLoading, setIsLoading] = useState(false);
    const [filtro, setFiltro] = useState("");
    const [recordForView, setRecordForView] = useState(null);
    const [analisesSolicitacao, setAnalisesSolicitacao] = useState([]);
    const [openResultado, setOpenResultado] = useState(false);
    const [fazFiscalizacao, setFazFiscalizacao] = useState(false);
    const [colunsLista, setColunsLista] = useState(columnsAnaliseSolicitacaoCompartilhamentoAnalise);

    const analises = useSelector((state) => state.analises);

    const onClickPesquisar = async () => {
        try {

            setIsLoading(true);

            const data = await servAnalises.ListarSolicitacoesCompartilhamentoAnalise(user.codigoUsuario, analises.codigoSolicCompart, filtro);

            let analiseSolic = data.Content;

            analiseSolic.map((analise) => {
                analise.id = analise.Id;
            });

            setAnalisesSolicitacao(analiseSolic);

            setIsLoading(false);

        } catch (err) {
            setIsLoading(false);

            console.log(err.Messsage);
        }
    };

    useEffect(() => {

        const recuperarAnalisesAnteriores = async () => {
            try {

                setIsLoading(true);

                const data = await servAnalises.ListarSolicitacoesCompartilhamentoAnalise(user.codigoUsuario, analises.codigoSolicCompart, "");

                let analiseSolic = data.Content;

                analiseSolic.map((analise) => {
                    analise.id = analise.Id;
                });

                setAnalisesSolicitacao(analiseSolic);

                setIsLoading(false);

            } catch (err) {

                setIsLoading(false);

            }
        };

        if (analises.codigoSolicCompart) {
            recuperarAnalisesAnteriores();
        }

        const buscarParametros = async () => {
            try {
                const [params, paramsMapa] = await Promise.all([
                    servSolicitacaoCompartilhamento.BuscarParametros(),
                    servConsultaDisponibilidade.BuscarParametros(),
                ]);

                const fazFiscalizacao = Boolean(params?.Content?.[0]?.FazFiscalizacao);
                const disponibilizaMapas = Boolean(paramsMapa?.Content?.[0]?.DisponibilizaMapas);

                setFazFiscalizacao(fazFiscalizacao);

                let novaLista = [...columnsAnaliseSolicitacaoCompartilhamentoAnalise];

                if (!disponibilizaMapas) {
                    novaLista = novaLista.filter(
                        (col) => col.field !== "ParecerProjeto" && col.field !== "DataParecerProjeto"
                    );
                } else {
                    novaLista = novaLista.map((col) =>
                        ["ParecerProjeto", "DataParecerProjeto"].includes(col.field)
                            ? { ...col, flex: 1 }
                            : col
                    );
                }

                if (!fazFiscalizacao) {
                    novaLista = novaLista.filter(
                        (col) => col.field !== "ParecerInstalacao" && col.field !== "DataParecerInstalacao"
                    );
                } else {
                    novaLista = novaLista.map((col) =>
                        ["ParecerInstalacao", "DataParecerInstalacao"].includes(col.field)
                            ? { ...col, flex: 1 }
                            : col
                    );
                }

                setColunsLista(novaLista);
            } catch (err) {
                console.error("Erro ao buscar parâmetros:", err);
            }
        };

        buscarParametros();

    }, [analises]);

    const handleRowClick = () => {
        if (recordForView === null) {
            return;
        }
        setRecordForView(recordForView);
        setOpenResultado(true);
    };

    return (
        <div className={styles.solicitacaoContainer}>
            <h2 style={{ margin: 0 }}>Análises da solicitação de compartilhamento</h2>
            <div className={styles.solicitacaoFiltros}>
                <FormControl>
                    <InputLabel shrink style={{ color: "#B8B8B8" }}>Data de apresentação</InputLabel>
                    <WhiteInput
                        value={filtro}
                        onChange={(e) => setFiltro(e.target.value)}
                        type="date"
                        id="pesquisa-data"
                        sx={{ width: "500px", marginRight: "10px" }} />
                </FormControl>
                <BlueHoverButton onClick={onClickPesquisar} variant="contained" style={{ marginTop: "15px" }}>
                    Pesquisar
                </BlueHoverButton>
            </div>
            <div>
                <Lista
                    columns={colunsLista}
                    rows={analisesSolicitacao}
                    onDblClick={handleRowClick}
                    setSelectedData={setRecordForView}
                    hideFooter={true}
                    autoHeight={true} />
            </div>
            <Popup title="Resultado da Análise" openPopup={openResultado} setOpenPopup={setOpenResultado} minHeight="100px">
                <ResultadoAnalise
                    record={analisesSolicitacao}
                    recordForView={recordForView}
                    setIsLoading={setIsLoading}
                    fazFiscalizacao={fazFiscalizacao}
                />
            </Popup>
            <Modal open={isLoading}>
                <Box style={modalstyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>

    );
}

export { Analises }